import React from 'react';
import axios from 'axios';

import { useTimeModal } from '../Components/TimeModal/TimeModalContext';

import Loading from '../Components/Loading';

import styles from '../styles/DynamicModal.module.css';

const ChangeEmailAMModal = ({ closeModal, id, onReloadTable }) => {
    const { openTimeModal } = useTimeModal();

    const [warning, setWarning] = React.useState('');
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        document.body.style.overflow = 'hidden';
    
        return () => {
            document.body.style.overflow = '';
        };
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.href = '/';
    };

    const [email, setEmail] = React.useState('');
    const [note, setNote] = React.useState('');
    React.useEffect(() => {
        const token = localStorage.getItem('token');

        if (token) {
            axios.get(`/api/email-am?id=${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then(response => {
                setEmail(response.data.email);
                setNote(response.data.note);
                setLoading(false);
            }).catch(err => {
                console.error('Ошибка получения данных '+err);
                setWarning('Ошибка получения данных: '+err.message);
                setLoading(false);
            });
        } else {
            handleLogout();
        }
    }, []);

    const changeData = (e) => {
        e.preventDefault();
        axios.put(`/api/change-emails-AM-data`, {
            id,
            email,
            note
        })
        .then(() => {
            openTimeModal(`Данные успешно обновлены`, 'success');
            closeModal();
        })
        .catch((error) => {
            console.error(error);
            openTimeModal(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
        })
    }


    return (
        <div className={styles.liningOver}>
            <form className={styles.lining} onClick={(e) => e.stopPropagation()} onSubmit={(e) => changeData(e)}>
                <div className={styles.header}>
                    <h1>Изменить данные арбитражного управляющего</h1>
                    <svg onClick={() => {closeModal(); onReloadTable()}} viewBox="0 0 24 24" fill="none">
                    <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"/>
                    </svg>
                </div>
                <div className={styles.main}>
                    {loading ? (
                        <Loading />
                    ) : warning ? (
                        <a>{warning}</a>
                    ) : (
                        <span style={{width: '320px', margin: '0 auto'}}>
                            <a style={{display: 'flex', justifyContent: 'center'}}>Измените адрес электронной почты</a>
                            <input type="email" placeholder='Введите e-mail' value={email} onChange={(e) => {setEmail(e.target.value)}} />
                            <a style={{display: 'flex', justifyContent: 'center'}}>Измените примечание</a>
                            <input type="text" placeholder='Введите примечание' maxLength='100' value={note} onChange={(e) => {setNote(e.target.value)}} />
                            <button className='button maxWidth' type='submit'>Подтвердить изменение данных</button>
                        </span>
                    )}
                </div>
            </form>
        </div>
    )
}

export default ChangeEmailAMModal;